import { defineStore } from "pinia"
import * as TYPE from "./type"
function initState() {
    return {
        subdivision: [],
        community: [],
        area: []
    }
}
export default storeName => 
    defineStore(storeName, {
        state: initState,
        actions: {
            [TYPE.UPDATE_COMMUNITY](community) {
                this.community = community
            },
            [TYPE.UPDATE_SUBDIVISION](subdivision) {
                this.subdivision = subdivision
            },
            [TYPE.UPDATE_AREA](area) {
                this.area = area
            }
        },
        getters: {
            allNears() {
                return [...this.community, ...this.subdivision].sort()
            }
        }
    })